import { createAction } from 'redux-act'

export const setApplePayAuthtoken = createAction<any>('set applePay auth status')
